import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { setUser } from "src/redux/service/user.service";
const ProtectedRoute = ({ children }) => {
  const authUserRaw = localStorage.getItem("user");
  const authUser = useMemo(() => (authUserRaw ? JSON.parse(authUserRaw) : null), [authUserRaw]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (authUser) {
      dispatch(setUser(authUser));
    }
  }, [dispatch, authUser]);

  if (authUser) {
    return children;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
